<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="title" label="标题">
        <el-input v-model="dataForm.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item prop="content" label="内容">
        <el-input v-model="dataForm.content" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
      </el-form-item>

      <!-- 对应域名 -->
      <el-form-item label="对应域名">
        <div v-for="(_, index) in dataForm.yum" :key="index" style="margin-bottom: 10px;
    display: flex;align-items: center;flex-direction: row;">
          <el-input
            v-model="dataForm.yum[index]"
            placeholder="请输入域名，例如：example.com"
            style="width: calc(100% - 50px); margin-right: 10px;">
          </el-input>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            @click="removeDomain(index)"
            :disabled="dataForm.yum.length === 1">
          </el-button>
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addDomain">
          新增域名
        </el-button>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        title: '',
        content: '',
        yum: ['']  // 默认有一个空的域名输入框
      }
    }
  },
  computed: {
    dataRule () {
      return {
        title: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (row) {
          // 直接使用传递过来的数据
          this.dataForm = {
            id: row.id || '',
            title: row.title || '',
            content: row.content || '',
            // 处理域名数据：如果是字符串（JSON格式），解析为数组；如果是数组直接使用；否则默认一个空输入框
            yum: row.yum
              ? (typeof row.yum === 'string' ? JSON.parse(row.yum) : row.yum)
              : ['']
          }
        } else {
          // 新增时清空表单
          this.dataForm = {
            id: '',
            title: '',
            content: '',
            yum: ['']
          }
        }
      })
    },

    // 新增域名输入框
    addDomain() {
      this.dataForm.yum.push('')
    },

    // 删除域名输入框
    removeDomain(index) {
      if (this.dataForm.yum.length > 1) {
        this.dataForm.yum.splice(index, 1)
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        // 过滤掉空的域名，只保留有值的
        const filteredYum = this.dataForm.yum.filter(domain => domain && domain.trim() !== '')

        // 检查是否有重复的域名
        const uniqueYum = new Set(filteredYum)
        if (uniqueYum.size !== filteredYum.length) {
          // 找出重复的域名
          const duplicates = filteredYum.filter((item, index) => filteredYum.indexOf(item) !== index)
          return this.$message.error(`域名不能重复，重复的域名：${duplicates.join(', ')}`)
        }

        // 创建要提交的数据对象
        const submitData = {
          ...this.dataForm,
          yum: filteredYum
        }

        this.$http[!this.dataForm.id ? 'post' : 'put']('/content/content', submitData).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
